// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".86d5f3179c906bf594bee6017902491340a3a616.chunk.js";
};